import React, { FunctionComponent } from 'react'
import { useDispatch } from 'react-redux'
import { ApolloError } from '@apollo/client'

import { Col } from '../../../../components/Table/next'
import VerticalSummaryTable from './Table'

import TableContext, {
  createTableContext,
} from '../../../../contexts/TableContext'
import { triggerError } from '../../../../actions/app'

import {
  VerticalSummaryReportingSorts,
  VerticalSummaryReportingPaginatedPayload,
  VerticalSummaryReportingQueryVariables,
} from '../../../../generated/types'

export type VerticalSummaryGroupBy = keyof Omit<
  VerticalSummaryReportingPaginatedPayload,
  '__typename'
>
export type VerticalSummaryVariables = VerticalSummaryReportingQueryVariables

export type VerticalSummarySorts = keyof VerticalSummaryReportingSorts

export type VerticalSummary = {
  groupBy: string
  dateRange: string
  startDate: string
  endDate: string
  productIds: string
  externalPropertyId: string
  userVariables: string
  vertical?: string
  program?: string
  product?: string
  productType?: number
  campaign?: string
  clickedProduct?: string
  subTracking?: string
}

export const VerticalSummaryTableContext = createTableContext<
  VerticalSummary,
  VerticalSummarySorts
>()

interface VerticalSummaryTableContainerProps {
  groupBy: VerticalSummaryGroupBy
  cols: Col[]
  footerPadding?: number
  getData: ({ variables }: { variables: VerticalSummaryVariables }) => void
  data: any
  loading: boolean
  error?: ApolloError
  getExportData: ({
    variables,
  }: {
    variables: VerticalSummaryVariables
  }) => void
  exportData: any
  exportLoading: boolean
  exportError?: ApolloError
}

const VerticalSummaryTableContainer: FunctionComponent<VerticalSummaryTableContainerProps> = ({
  groupBy,
  cols,
  footerPadding,
  getData,
  data,
  loading,
  error,
  getExportData,
  exportData,
  exportLoading,
  exportError,
}) => {
  const dispatch = useDispatch()

  // TODO: We should refactor this out with RVMN-235
  if (error) {
    dispatch(triggerError(error.message, 'Vertical Summary'))
  }

  return (
    <TableContext<VerticalSummary, VerticalSummarySorts>
      Context={VerticalSummaryTableContext}
      queryParams={['groupBy', 'dateRange', 'startDate', 'endDate']}
      defaultFilters={{
        groupBy: 'byDate',
        vertical: '5',
      }}
      defaultSort={{
        by: 'day',
        dir: 'desc',
      }}
    >
      <VerticalSummaryTable
        groupBy={groupBy}
        cols={cols}
        footerPadding={footerPadding}
        getData={getData}
        data={data}
        loading={loading}
        error={error != null}
        getExportData={getExportData}
        exportData={exportData}
        exportLoading={exportLoading}
        exportError={exportError != null}
      />
    </TableContext>
  )
}

export default VerticalSummaryTableContainer
